import { fetchRefreshedTokens as fetchRefreshedTokensFromAuth } from '@discover-frontend/auth';

export const fetchRefreshedTokens = (refreshToken) =>
  fetchRefreshedTokensFromAuth(refreshToken, process.env.REACT_APP_API_ENV);
